<template>
  <td>
    <span class="action-icon nt-edit k-link" @click="editHandler"></span>
    <span
      type="button"
      class=" ml-3 action-icon k-link"
      @click="auditHandler"
      v-b-toggle.sidebar-right
    >
      <span class="nt-clock"></span>
    </span>
  </td>
</template>

<script>
export default {
  props: {
    dataItem: Object,
    columnIndex: Number,
  },
  watch: {
    dataItem: function(newVal) {
      this.item = newVal;
    },
  },
  methods: {
    editHandler: function() {
      this.$emit("edit", { dataItem: this.item });
    },
    auditHandler: function() {
      this.$emit("audit", { dataItem: this.item });
      
    },
  },
  data: function() {
    return {
      item: { ...this.dataItem },
    };
  },
};
</script>

<style></style>
